import find from "lodash/find";
import { useProfiles } from "PFCore/hooks/queries/profiles/use_profiles";
import { Profile, VacanciesCollection, Vacancy } from "PFTypes";
import { useMemo } from "react";

type UseVacancyProfileReturn = {
  getVacancyProfiles: (vacancy: Vacancy) => Profile[];
  getVacancyFilledRole: (vacancy: Vacancy) => Vacancy | undefined;
  isFetching: boolean;
};

export const useVacancyProfile = (vacancies?: VacanciesCollection): UseVacancyProfileReturn => {
  const vacanciesFilledProfiles = useMemo(
    () => (vacancies?.entries || []).filter((item) => item.state !== "opened"),
    [vacancies?.entries]
  );

  const filledProfilesIds = useMemo(
    () => vacanciesFilledProfiles.flatMap(({ profileIds }) => profileIds),
    [vacanciesFilledProfiles]
  );

  const { data: vacanciesProfiles, isFetching } = useProfiles(
    {
      filters: {
        fields: { id: filledProfilesIds }
      },
      perPage: filledProfilesIds.length
    },
    {
      enabled: filledProfilesIds.length > 0
    }
  );

  const getVacancyProfiles = (vacancy: Vacancy): Profile[] =>
    vacanciesProfiles?.entries
      .filter(({ id }) => !!vacancy.profileIds?.includes(id))
      .map(({ profile }) => profile) ?? [];
  const getVacancyFilledRole = (vacancy: Vacancy) => find(vacanciesFilledProfiles, ["id", vacancy.id]);

  return {
    getVacancyProfiles,
    getVacancyFilledRole,
    isFetching
  };
};
